export default __webpack_public_path__ + "static/media/alert.a9bd45b3.less";